import React, { useContext, useEffect, useState, useMemo } from "react";
import "./styles.scss";
import { SkeletonLoader } from "Components/Skeletion";
import { useWindowSize } from "Utilities";
import RenderContext from "Context/RenderContext";
import { useTranslation } from 'react-i18next';

const InfoBlock = ({ getInfo = [], loading = false }) => {
  const [width] = useWindowSize();
  const [count, setCount] = useState(2);
  const [showButton, setShowButton] = useState(true);
  const { loadPreRender } = useContext(RenderContext);
  const { t } = useTranslation();

  const removeIframes = (html) =>
    html.replace(/<iframe[^>]*>.*?<\/iframe>/gi, "");

  useEffect(() => {
    if (width >= 640) {
      setCount(getInfo.length);
      setShowButton(false);
    } else {
      setCount(2);
      setShowButton(getInfo.length > 2);
    }
  }, [width, getInfo]);

  const content = useMemo(() => {
    if (loading) {
      return Array.from({ length: 4 }, (_, index) => (
        <div key={`InfoBlock_Loading_${index}`} className="pb-5">
          <h4 className="mb-2 fw-700 line-8 pb-3">
            <SkeletonLoader height="34px" />
          </h4>
          <SkeletonLoader length={12} height="20px" pclassName="flex col gap-2" />
        </div>
      ));
    }

    return getInfo.slice(0, count).map((item, index) => (
      <div
        key={`home__static__content${index}`}
        className="pb-5"
        dangerouslySetInnerHTML={{
          __html: loadPreRender ? removeIframes(item?.block) : item?.block,
        }}
      />
    ));
  }, [loading, getInfo, count, loadPreRender]);

  const handleShowMore = () => {
    setCount(getInfo.length);
    setShowButton(false);
  };

  return (
    <section className="infoBlock" aria-label="info-block">
      <div className="container pt-6 pb-3 xl-pt-9 xl-pb-6 px-4">
        <div className={`info__wrapper flex col gap-y-2 xl-flex xl-row wrap xl-gap-x-14 relative zindex-0 infoblock__plp text_block ${showButton ? "open" : ""}`}>
          {content}
          {showButton && (
            <div className="button__block w-1/1 tc md-hide zindex-1 pb-2">
              <button
                aria-label="Lees meer"
                className="primary__btn fw-700"
                onClick={handleShowMore}
              >
                <div className="no-translate notranslate">{t("Readmore")}</div>
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default InfoBlock;
